import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { instance as axios } from "../axios/instance";

type SyncStatus = "inProgress" | "completed" | "failed";
const useClientSync = (clientId: string) => {
  const [syncStatus, setSyncStatus] = useState<SyncStatus | null>(null);  
  const mut = useMutation({
    mutationFn: async () => {
      setSyncStatus("inProgress");

      const response = await axios.post(
        `/api/v2/Sync/${clientId}/RecruitNow/Publications`
      );
      return response.data;
    },
    onSuccess: async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setSyncStatus("completed");
    },
    onError: () => {
      setSyncStatus("failed");
    },
  });
  return {
    startSync: {
      exec: mut.mutateAsync,
      isSuccess: mut.isSuccess,
      isError: mut.isError,
      error: mut.error,
      isPending: mut.isPending,
    },
    syncStatus,
  };
};

export default useClientSync;
